import { Flex } from "../../../../../components/flex/Flex"
import { Button } from "../../../../../components/button/Button"
import SvgArrowBack from "../../../../../images/xd/icons/ArrowBack"
import { styled } from "@stitches/react"
import { theme } from "../../../../../styles/stitches.config"
import { Span } from "../../../../../components/span/Span"
import { ReactNode } from "react"

type Props = {
  prevText: ReactNode
  nextText: ReactNode
  onReturn?: () => void
  onContinue?: () => void
  validationCompleted?: boolean
  isSubmitting?: boolean
}

const NavButton = styled(Button, {
  height: `${theme.sizes.s15_5} !important`,
  justifyContent: "space-between !important",
  textTransform: "uppercase",
  fontWeight: `${theme.fontWeights.bold} !important`,
  boxShadow: "none !important",
  fontSize: `${theme.fontSizes.regular}!important`,
})

export function NavigationButtons(prop: Props) {
  const { prevText, nextText, onReturn, validationCompleted, isSubmitting } = prop

  return (
    <Flex
      justify="center"
      align="center"
      direction="columnReverse"
      css={{ gap: "27px", marginBottom: theme.space.s6, "@sm": { flexDirection: "row" } }}
    >
      <NavButton type="button" variant="secondary" onClick={onReturn} css={{ paddingLeft: "16px" }}>
        <SvgArrowBack width={24} height={24} />
        <Span>{prevText}</Span>
      </NavButton>
      <NavButton
        type="submit"
        variant="primary"
        disabled={validationCompleted === false}
        css={{ paddingRight: "16px" }}
        isSubmitting={isSubmitting}
      >
        <Span>{nextText}</Span>
        <SvgArrowBack width={24} height={24} style={{ transform: "rotate(180deg)" }} />
      </NavButton>
    </Flex>
  )
}
